
import React from 'react'; 
import styles from './ProgressBar.module.scss';

export interface IProgressBarProps{
    width?: number;
    fadeInDelay?: number;
    noAnimation?: boolean;
}

export const ProgressBar = (props:IProgressBarProps)=>{

    let {width,fadeInDelay,noAnimation} = props||{};
        
    const inlineStyles = {
        width: width,
        animationDelay: noAnimation && fadeInDelay ? fadeInDelay + 'ms' : '0ms'
    };

    let containerClass = `${styles.loadingBar} ${noAnimation ? styles.loadingBarInstant : styles.loadingBarAnimated}`;
    return (
        <div className={containerClass} style={inlineStyles}>
            <div className={styles.bar} />
        </div>
    );
    
    

};